/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PartnerJoinRequestDto } from '../../models/partner-join-request-dto';

export interface PartnerJoinRequestControllerFindAll$Params {
}

export function partnerJoinRequestControllerFindAll(http: HttpClient, rootUrl: string, params?: PartnerJoinRequestControllerFindAll$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<PartnerJoinRequestDto>>> {
  const rb = new RequestBuilder(rootUrl, partnerJoinRequestControllerFindAll.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<PartnerJoinRequestDto>>;
    })
  );
}

partnerJoinRequestControllerFindAll.PATH = '/api/partner-join-request';
